export const ROUTE_NAME = Object.freeze({
  HOME: 'home',
  DASHBOARD: 'dashboard',
  AI_DASHBOARD: 'ai-dashboard',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  LOGOUT: 'logout',
  ERROR: 'error',
  //Agent
  AGENT_LIST: 'agent-list',
  AGENT_CREATE: 'agent-create',
  AGENT_DETAILS: 'agent-details',
  //User
  USER_LIST: 'user-list',
  USER_CREATE: 'user-create',
  USER_DETAILS: 'user-details',
  USER_RESET_PASSWORD: 'user-reset-password',
  //AI User
  AI_USER_LIST: 'ai-user-list',
  AI_USER_CREATE: 'ai-user-create',
  AI_USER_DETAILS: 'ai-user-details',
  AI_USER_RESET_PASSWORD: 'ai-user-reset-password',
  //Role
  ROLE_LIST: 'role-list',
  ROLE_CREATE: 'role-create',
  ROLE_DETAILS: 'role-details',
  //Product
  PRODUCT_LIST: 'product-list',
  PRODUCT_CREATE: 'product-create',
  PRODUCT_DETAILS: 'product-details',
  //Application Types
  APPLICATION_TYPE_LIST: 'application-type-list',
  APPLICATION_TYPE_CREATE: 'application-type-create',
  APPLICATION_TYPE_DETAILS: 'application-type-details',
  //Company
  COMPANY_LIST: 'company-list',
  COMPANY_CREATE: 'company-create',
  COMPANY_DETAILS: 'company-details',
  //Bank
  BANK_LIST: 'bank-list',
  BANK_CREATE: 'bank-create',
  BANK_DETAILS: 'bank-details',
  //Commission Rate
  COMMISSION_RATE_LIST: 'commission-rate-list',
  COMMISSION_RATE_CREATE: 'commission-rate-create',
  COMMISSION_RATE_DETAILS: 'commission-rate-details',
  //AI Commission Rate
  AI_COMMISSION_RATE_LIST: 'ai-commission-rate-list',
  AI_COMMISSION_RATE_CREATE: 'ai-commission-rate-create',
  AI_COMMISSION_RATE_DETAILS: 'ai-commission-rate-details',
  //Customer Application
  CUSTOMER_APPLICATION_LIST: 'customer-application-list',
  CUSTOMER_APPLICATION_CREATE: 'customer-application-create',
  CUSTOMER_APPLICATION_DETAILS: 'customer-application-details',
  APPLICATION_HISTORY: 'application-history',
  APPLICATION_HISTORY_DETAILS: 'application-history-details',
  //AI Application
  AI_APPLICATION_LIST: 'ai-application-list',
  AI_APPLICATION_CREATE: 'ai-application-create',
  AI_APPLICATION_DETAILS: 'ai-application-details',
  AI_APPLICATION_HISTORY: 'ai-application-history',
  AI_APPLICATION_HISTORY_DETAILS: 'ai-application-history-details',
  //Domain
  DOMAIN_LIST: 'domain-list',
  DOMAIN_CREATE: 'domain-create',
  DOMAIN_DETAILS: 'domain-details',
  //Claim Submission
  CLAIM_SUBMISSION_LIST: 'claim-submission-list',
  CLAIM_SUBMISSION_DETAILS: 'claim-submission-details',
  //Claim Payout
  CLAIM_PAYOUT_LIST: 'claim-payout-list',
  CLAIM_PAYOUT_DETAILS: 'claim-payout-details',
  CLAIM_PAYOUT_HISTORY: 'claim-payout-history',
  //Claim Payout
  CLAIM_HISTORY_LIST: 'claim-history-list',
  CLAIM_HISTORY_DETAILS: 'claim-history-details',
  //Claim Reconcile
  CLAIM_RECONCILE_LIST: 'claim-reconcile-list',
  CLAIM_RECONCILE_DETAILS: 'claim-reconcile-details',
  //Ansuran Claim Submission
  AI_CLAIM_SUBMISSION_LIST: 'ai-claim-submission-list',
  AI_CLAIM_SUBMISSION_DETAILS: 'ai-claim-submission-details',
  //Ansuran Claim Payout
  AI_CLAIM_PAYOUT_LIST: 'ai-claim-payout-list',
  AI_CLAIM_PAYOUT_DETAILS: 'ai-claim-payout-details',
  //Ansuran Claim History
  AI_CLAIM_HISTORY_LIST: 'ai-claim-history-list',
  AI_CLAIM_HISTORY_DETAILS: 'ai-claim-history-details',
  //Ansuran Claim Reconcile
  AI_CLAIM_RECONCILE_LIST: 'ai-claim-reconcile-list',
  AI_CLAIM_RECONCILE_DETAILS: 'ai-claim-reconcile-details',
  //Ansuran Report
  AI_REPORT_SALES_TRANSACTION: 'ai-report-sales-transaction',
  //Report
  REPORT_CLAIM_SUBMISSION: 'report-claim-submission',
  REPORT_CLAIM_PAYOUT: 'report-claim-payout',
  REPORT_SALES_TRANSACTION: 'report-sales-transaction',
  // AI report
  AI_REPORT_CLAIM_SUBMISSION: 'ai-report-claim-submission',
  AI_REPORT_CLAIM_PAYOUT: 'ai-report-claim-payout',
  AI_REPORT_SALES_TRANSACTION: 'ai-report-sales-transaction'
})
